export default [
  {
    header: " ",
  },
  {
    title: "Shop", // ตัวอย่างการใช้ เปลี่ยนภาษา nav
    icon: "HomeIcon",
    children: [
      {
        title: "ShopDetails",
        route: "shop-home",
      },
    ],
  },

  {
    title: "OrderList",
    route: "order-list",
    icon: "FileTextIcon",
  },
  {
    title: "Product",

    icon: "ArchiveIcon",
    children: [
      {
        title: "MyProduct",
        route: "product-list",
      },
      {
        title: "TheProductIsSuspended",
        route: { name: "product-ban" },
      },
    ],
  },
  {
    title: 'Finance',
    icon: 'DollarSignIcon',
    children: [
      // {
      //   title: 'MyIncome',
      //   route: 'my-income',
      // },
      // {
      //   title: 'SellerBalance',
      //   route: { name: 'seller-balance' },

      // },
      {
        title: 'MyBank',
        route: { name: 'my-bank' },
      },
    ],
  },
  {
    title: "ShopRating",
    icon: "StarIcon",
    route: "point-shop",
  },
  {
    title: "Settings",
    icon: "SettingsIcon",
    route: "setting-page",
  },
];
